const _ = (data: any) => {
  const products: any = [];
  const product = {
    name: data?.productNumber,
    id: data?.productNumber,
    price: data?.price || data?.unitPrice,
    brand: data?.manufacturerCode,
    quantity: data?.quantity
  };
  products.push(product);
  return products;
};

export default (data: any, event: string) => {
  const itemsList = _(data);
  return {
    event,
    ecommerce: {
      remove: {
        products: itemsList
      }
    }
  };
};
